export enum UserDataState {
  EMPTY = 'Empty',
  REQUESTED = 'Requested',
  LOADING = 'Loading',
  LOADED = 'Loaded',
}
